import React, { useContext, useState } from "react";
import Fade from "@material-ui/core/Fade";
import { Menu, MenuItem, Tooltip, withStyles } from "@material-ui/core";
import { Link, LinkProps } from "react-router-dom";
import clsx from "clsx";
import DialogBoxButton from "../DialogBoxButton";
import { CoreDialogBoxProps } from "../DialogBox";
import styles from "./DropdownMenu.module.scss";
import PermissionContext, { 
  useUserPermission,
} from "../../routing/contexts/PermissionContext";
import PermissionArea from "../../Authentication/model/PermissionArea";
import Permission from "../../Authentication/model/Permission";
import auditSharingPermission from "../../Enums/AuditSharingPermission";
import VerifyPDFToolTip from "../../Enums/VerifyPDFToolTip";
import { dispatch } from "../App/App";
import { setVerifyLimit } from "../../store/details/actions/getTableFilterInputs";

export enum DropdownMenuItemType {
  LINK,
  BUTTON,
  BUTTON_CONFIRM,
  BUTTON_VERIFY_LIMIT_CONFIRM
}

interface DropDownMenuLink extends CoreDropdownMenuItem {
  readonly type: DropdownMenuItemType.LINK;
  readonly link: string;
  readonly state?: object;
}

interface DropdownMenuButton extends CoreDropdownMenuItem {
  readonly type: DropdownMenuItemType.BUTTON;
  readonly onClick: () => void;
}

interface DropDownMenuButtonConfirm
  extends CoreDialogBoxProps,
    CoreDropdownMenuItem {
  readonly type: DropdownMenuItemType.BUTTON_CONFIRM;
}

interface DropDownMenuButtonVerifyLimitConfirm
  extends CoreDialogBoxProps,
    CoreDropdownMenuItem {
  readonly type: DropdownMenuItemType.BUTTON_VERIFY_LIMIT_CONFIRM;
  companyId:string;
  currentVerifyFavLimit:any;
}

interface CoreDropdownMenuItem {
  readonly label: string;
  readonly icon: JSX.Element;
  readonly hide?: boolean;
  readonly permissionRequired: {
    readonly area?: PermissionArea;
    readonly permission: Permission;
  }[];
  readonly disabled?: boolean;
  readonly onHoverText?: string;
}

export type DropdownMenuItem =
  | DropDownMenuLink
  | DropdownMenuButton
  | DropDownMenuButtonConfirm
  | DropDownMenuButtonVerifyLimitConfirm;

interface DropdownMenuProps {
  readonly target: HTMLElement | null;
  readonly onClose: () => void;
  readonly items: DropdownMenuItem[];
}

const PDFTooltip = withStyles({
  tooltip: {
    color: "white",
    backgroundColor: "grey",
    width:"200px"
  }
})(Tooltip);

const renderLink = (item: DropDownMenuLink) => {
  const [link, search] = item.link.split("?");
  const toData = {
    pathname: link,
    state: item.state,
    search,
  };
  return (
    <MenuItem
      className={styles.menuItem}
      to={toData}
      component={React.forwardRef<HTMLAnchorElement, LinkProps>(
        (props, ref) => {
          // eslint-disable-next-line react/prop-types
          const { className } = props;
          return (
            <Link
              {...props}
              innerRef={ref}
              ref={ref}
              className={clsx(className, styles.link)}
            />
          );
        }
      )}
    >
      {item.icon} {item.label}
    </MenuItem>
  );
};
const renderButton = (item: DropdownMenuButton) => {

  if(item.disabled && item.onHoverText)
  {
    return <PDFTooltip title={item.onHoverText}>
      <MenuItem className={clsx(styles.menuItem, "disabledMenuItem")} onClick={() => {}} style={{cursor: 'not-allowed'}}>
      {item.icon} {item.label}      
      </MenuItem>
    </PDFTooltip>
  }

  return  <PDFTooltip title={item.label.length > 0 && item.label.includes("Certificate Unavailable_") && 
   item.label.split("_")[1] == auditSharingPermission.CertificateOnly?VerifyPDFToolTip.BasicOnlyORCertificateOnly:item.label.split("_")[1] == auditSharingPermission.CertificatePDF &&
    item.label.split("_")[2]=="Certificated"?VerifyPDFToolTip.CertificatePDFCertificatednoFile:item.label.split("_")[1] == auditSharingPermission.CertificatePDF &&
     item.label.split("_")[2]!="Certificated"?VerifyPDFToolTip.CertificatePDFNotCertificated:""}>
  <MenuItem 
    className={ item.label.includes("Certificate Unavailable_")?clsx(styles.menuItem,"disabledMenuItem"):clsx(styles.menuItem, styles.button)}
    onClick={item.onClick} 
    >
   {item.icon} {item.label.includes("Certificate Unavailable_")? item.label.split("_")[0]:item.label}
  </MenuItem>
  </PDFTooltip>
};

const renderConfirmButton = (item: DropDownMenuButtonConfirm) => {
  const openButton = (openDialog: () => void) => (
    <MenuItem
      className={clsx(styles.menuItem, styles.button)}
      onClick={openDialog}
    >
      {item.icon} {item.label}
    </MenuItem>
  );

  const {
    onConfirm,
    acceptButtonText,
    declineButtonText,
    dialogHeader,
    children
  } = item;
  return (
    <DialogBoxButton
      onConfirm={onConfirm}
      acceptButtonText={acceptButtonText}
      declineButtonText={declineButtonText}
      dialogHeader={dialogHeader}
      openButton={openButton}
    >
      {children}
    </DialogBoxButton>
  );
};


const DropdownMenu = ({ target, onClose, items }: DropdownMenuProps) => {
  const [verifyTagLimit, setVerifyTagLimit] = useState("");
  const handleChange = (e:any) => {
    const input = e.target.value;   
    if (input != undefined && input.trim() != "")
      {  
        setVerifyTagLimit(input);
        dispatch(setVerifyLimit(input));
      }
  };
  const renderVerifyTagLimitConfirmButton = (item: DropDownMenuButtonVerifyLimitConfirm) => {    
    const openButton = (openDialog: () => void) => (
      <MenuItem
        className={clsx(styles.menuItem, styles.button)}
        onClick={openDialog}
      >
        {item.icon} {item.label}
      </MenuItem>
    );    
    const {
      onConfirm,
      acceptButtonText,
      declineButtonText,
      dialogHeader,
      children,
      companyId,
      currentVerifyFavLimit    
    } = item;
    return (
      <DialogBoxButton
        onConfirm={onConfirm}
        acceptButtonText={acceptButtonText}
        declineButtonText={declineButtonText}
        dialogHeader={dialogHeader}
        openButton={openButton}
      >
        {children}       
        <label className="verify-tag-limit"> Company ID : {companyId} </label>
       <br></br><label>Current Certificate Tracker favourites limit : {currentVerifyFavLimit}</label>
       <br></br><br></br><label htmlFor="verifyTagLimit">
        Set new limit : 
          <input className="verify-tag-limit-texbox" type="number" required={true}
            placeholder=""
            id="verifyTagLimit"           
            onBlur={handleChange}
          />
        </label> 
      </DialogBoxButton>
    );
  };
  const permissionContext = useContext(PermissionContext) as PermissionArea;
  const userPermissions = useUserPermission();
  const filteredItems = items
    .filter(({ permissionRequired, hide }) => {
      if (hide) return false;
      if (permissionRequired.length === 0) return true;
      return permissionRequired.some(
        ({ permission, area: permissionTarget }) => {
          let userPermissionsForTarget =
            userPermissions[permissionTarget ?? permissionContext] ?? [];
          if (permissionContext === PermissionArea.SUB_OFFICE) {
            // Making sure CBs are granted full access to their sub-offices.
            userPermissionsForTarget = [
              ...userPermissionsForTarget,
              ...userPermissions[PermissionArea.CB],
            ];
          }
          return userPermissionsForTarget.includes(permission);
        }
      );
    })
    .map((item) => {
      switch (item.type) {
        case DropdownMenuItemType.LINK:
          return renderLink(item);
        case DropdownMenuItemType.BUTTON:
          return renderButton(item);
        case DropdownMenuItemType.BUTTON_CONFIRM:
          return renderConfirmButton(item);
        case DropdownMenuItemType.BUTTON_VERIFY_LIMIT_CONFIRM:
          return renderVerifyTagLimitConfirmButton(item);
        default:
          return null;
      }
    });
  return (
     
//     <Tooltip title={"Certificate PDF unavailable: access prohibited by Audit Owner"}
      
//     > 
//  <span>

    <Menu
      className={styles.dropdownMenu}
      anchorEl={target}
      keepMounted
      open={Boolean(target)}
      onClose={onClose}
      TransitionComponent={Fade}
    >
      {filteredItems.length > 0 ? (
        filteredItems
      ) : (
        <MenuItem disabled>No options available</MenuItem>
      )}
    </Menu>
  //</span>
  // </Tooltip>
  );
};

export default DropdownMenu;
